import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Erro capturado:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            fontFamily: 'sans-serif',
            gap: '16px'
          }}
        >
          <h2 style={{ margin: 0 }}>Algo deu errado.</h2>
          <p style={{ margin: 0, color: '#666' }}>
            Ocorreu um erro inesperado na interface.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 20px',
              cursor: 'pointer',
              borderRadius: '4px',
              border: '1px solid #ccc'
            }}
          >
            Recarregar
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
